import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from '@angular/common/http';
import { inject } from '@angular/core';

import { DsLoggingService, ErrorSource } from '@cubigo/digital-signage';

import { catchError, from, switchMap, tap, throwError } from 'rxjs';

import { AuthService } from 'app/shared/services';
import { FeedHealthService } from 'app/shared/services/feed-health.service';

import { SIGNAGE_API, TOKEN_ENDPOINT } from './signage-api-context';

export const errorInterceptor: HttpInterceptorFn = (request, next) => {
  const auth = inject(AuthService);
  const logging = inject(DsLoggingService);
  const feeds = inject(FeedHealthService);
  const sentToken = auth.accessToken;

  return next(request).pipe(catchError((error: unknown) => {
    logging.logError(error, request.context.get(SIGNAGE_API) ? ErrorSource.Api
      : request.context.get(TOKEN_ENDPOINT) ? ErrorSource.TokenEndpoint : ErrorSource.HttpOther);

    if (!(error instanceof HttpErrorResponse) || error.status !== 401 || !request.context.get(SIGNAGE_API)) {
      return throwError(() => error);
    }

    const recovered = sentToken !== auth.accessToken && auth.isTokenValid
      ? Promise.resolve(true)
      : auth.refreshToken();
    return from(recovered).pipe(switchMap(success => success ? next(request) : throwError(() => error)));
  }), tap({
    next: event => {
      if (event instanceof HttpResponse && request.context.get(SIGNAGE_API)) {
        feeds.record(request.urlWithParams, true);
      }
    },
    error: () => {
      if (request.context.get(SIGNAGE_API)) {
        feeds.record(request.urlWithParams, false);
      }
    }
  }));
};
